const stickerDescriptionMedia = window.matchMedia('(max-width: 749px)');

function initStickerProduct(root) {
  if (root.dataset.stickerReady) return;
  root.dataset.stickerReady = 'true';

  const money = (cents) => window.PDCart?.money?.(cents) || `${(Number(cents || 0) / 100).toFixed(2)}`;
  const thumbs = [...root.querySelectorAll('[data-sticker-thumb]')];
  const media = [...root.querySelectorAll('[data-sticker-media]')];

  const showMedia = (mediaId) => {
    thumbs.forEach((thumb) => {
      if (thumb.dataset.mediaId === String(mediaId)) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
    media.forEach((panel) => { panel.hidden = panel.dataset.stickerMedia !== String(mediaId); });
  };

  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId)));

  const quantity = root.querySelector('input[name="quantity"]');
  root.querySelectorAll('[data-sticker-quantity]').forEach((button) => button.addEventListener('click', () => {
    const current = Math.max(1, Number.parseInt(quantity?.value || '1', 10));
    if (quantity) quantity.value = button.dataset.stickerQuantity === 'increase' ? current + 1 : Math.max(1, current - 1);
  }));

  const description = root.querySelector('[data-sticker-description-content]');
  const descriptionToggle = root.querySelector('[data-sticker-description-toggle]');
  const descriptionLabel = descriptionToggle?.querySelector('[data-sticker-description-label]');
  if (description && descriptionToggle && descriptionLabel) {
    const updateDescription = () => {
      description.classList.remove('is-collapsed');
      descriptionToggle.hidden = true;
      descriptionToggle.setAttribute('aria-expanded', 'true');
      descriptionLabel.textContent = 'Show less';

      if (!stickerDescriptionMedia.matches || description.scrollHeight <= 260) return;

      description.classList.add('is-collapsed');
      descriptionToggle.hidden = false;
      descriptionToggle.setAttribute('aria-expanded', 'false');
      descriptionLabel.textContent = 'Read more';
    };

    descriptionToggle.addEventListener('click', () => {
      const expanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
      description.classList.toggle('is-collapsed', expanded);
      descriptionToggle.setAttribute('aria-expanded', String(!expanded));
      descriptionLabel.textContent = expanded ? 'Read more' : 'Show less';
    });
    stickerDescriptionMedia.addEventListener('change', updateDescription);
    updateDescription();
  }

  const variant = root.querySelector('[data-sticker-variant]');
  const price = root.querySelector('[data-sticker-price]');
  const compare = root.querySelector('[data-sticker-compare]');
  const sale = root.querySelector('[data-sticker-sale]');
  const add = root.querySelector('[data-sticker-add]');
  const addLabel = root.querySelector('[data-sticker-add-label]');

  const updateVariant = () => {
    const option = variant?.selectedOptions?.[0];
    if (!option) return;
    const variantPrice = Number(option.dataset.price || 0);
    const comparePrice = Number(option.dataset.compare || 0);
    const available = option.dataset.available === 'true';
    const onSale = comparePrice > variantPrice;
    if (price) price.textContent = money(variantPrice);
    if (compare) { compare.textContent = onSale ? money(comparePrice) : ''; compare.hidden = !onSale; }
    if (sale) sale.hidden = !onSale;
    if (add) add.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
    if (option.dataset.mediaId) showMedia(option.dataset.mediaId);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  };

  variant?.addEventListener('change', updateVariant);

  const form = root.querySelector('form[data-ajax-product-form]');
  form?.addEventListener('submit', async (event) => {
    if (!window.fetch || !window.PDCart?.refresh || add?.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    const status = root.querySelector('[data-product-status]');
    const availableLabel = addLabel?.textContent || 'Add to cart';
    add?.setAttribute('aria-busy', 'true');
    if (add) add.disabled = true;
    if (addLabel) addLabel.textContent = 'Adding…';
    if (status) status.textContent = '';
    try {
      const response = await fetch(window.PDTheme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      await window.PDCart.refresh(true);
      if (status) status.textContent = 'Added to your cart.';
    } catch (error) {
      if (status) status.textContent = error.message;
    } finally {
      add?.removeAttribute('aria-busy');
      const selected = variant?.selectedOptions?.[0];
      const available = selected ? selected.dataset.available === 'true' : true;
      if (add) add.disabled = !available;
      if (addLabel) addLabel.textContent = available ? availableLabel : 'Sold out';
    }
  });
}

document.querySelectorAll('[data-sticker-product]').forEach(initStickerProduct);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-sticker-product]').forEach(initStickerProduct));
